/**
 * Filipino: Workflows P5-7, ang hakbang na Verify e-mail (`verify_email`). Kapareho ng hugis ng English na teksto;
 * isinasama sa `engage.workflows`.
 */
export const workflowsVerify = {
  steps: { verify_email: "I-verify ang e-mail" },
  summaries: { verify_email: "Magpapadala ng code sa kilalang e-mail · {{message}}" },
  exits: { verified: "Na-verify", verificationFailed: "Hindi na-verify" },
  fields: {
    verifyIntro: "Mensahe bago ang code",
    verifyIntroHint: "Lalabas kasama ng button na Ipadala ang code. Ang code, ang naka-mask na address at ang mga button ay idinadagdag para sa iyo.",
    verifyCollectFirst: "Kailangang alam na ang e-mail ng bisita sa hakbang na ito. Kunin muna ito sa hakbang na Kunin ang data na nagse-save sa e-mail ng bisita, kung hindi ay dadaan ito sa path na Hindi na-verify.",
    verifiedGoTo: "Kapag tama ang code, pumunta sa",
    verifiedHint: "Mamarkahang na-verify ang e-mail ng bisita, kaya totoo na ang kondisyong “Na-verify ang bisita” mula rito.",
    failedGoTo: "Kapag hindi ma-verify, pumunta sa",
    failedHint: "Walang kilalang e-mail, maling code, nag-expire na code, mga mensaheng hindi code, o napakaraming code na hiningi para sa address.",
    verifyHow: {
      title: "Paano ito gumagana",
      address: "Makakatanggap ang bisita ng {{digits}}-digit na code sa e-mail address na kilala na ng workflow.",
      lifetime: "Gumagana ang code sa loob ng {{minutes}} minuto at isang beses lang.",
      failures: "{{wrong}} maling code, {{other}} mensaheng hindi code, o nag-expire na code ay dadaan sa path na Hindi na-verify.",
      resend: "Bubukas ang “Ipadala ulit ang code” {{seconds}} segundo pagkatapos ng unang code, isang beses lang.",
      verified: "Ang tamang code ay magmamarka sa e-mail ng bisita bilang na-verify. Walang nasa-sign in at walang nagbabagong audience.",
      preview: "Sa Playground, walang ipapadalang e-mail: i-type ang {{code}} para magpatuloy.",
    },
  },
  builder: {
    channelNotes: {
      steps: {
        verify_email: {
          web: "Web chat, web app at mobile: tina-tap ng bisita ang “Ipadala ang code”, na sinusuri laban sa mga bot, saka ita-type ang code sa chat box.",
          messenger: "Messenger: ipapadala ang code sa e-mail pagdating sa hakbang (walang bot check, mga rate limit lang). Ita-type ng bisita ang code, o RESEND pagkalipas ng isang minuto.",
          email: "E-mail: mapupunta ang code sa kilalang address pagdating sa hakbang. Sasagot ang bisita ng code sa itaas ng naka-quote na teksto.",
          api: "Hindi tumatakbo sa developer API channel ang mga hakbang na nakikita ng bisita.",
          preview: "Playground: walang ipapadalang e-mail. Ang code ay 123456 at walang isinusulat sa bisita.",
        },
      },
    },
  },
  runs: {
    endedReasons: { verification_failed: "Hindi na-verify ang e-mail." },
    reasons: {
      no_email: "Walang kilalang e-mail address",
      expired: "Nag-expire ang code",
      too_many_attempts: "Napakaraming maling code",
      not_a_code: "Mga mensaheng hindi code",
      rate_limited: "Napakaraming code ang hiningi para sa address",
      send_failed: "Hindi naipadala ang code",
      blocked: "Naka-block ang contact record",
      unavailable: "Hindi available ang verification",
    },
  },
  analysis: { outcomes: { verified: "Na-verify", failed: "Hindi na-verify", expired: "Nag-expire ang code" } },
};
